import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_global_get_init_country_message } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import Header from "../../fragments/heading/index";
import { FormattedMessage } from 'react-intl'

const FAQContentItem = props =>{
    const { content } = props;
    const [show, setShow] = useState(false);

    return <div>
        <div className={classes.FAQContentItem} onClick={() => setShow(state=>!state)}>
            <div dangerouslySetInnerHTML={{ __html:content?.title }}></div>
        </div>

        <div style={{display:`${show ? 'block' : 'none'}`}} dangerouslySetInnerHTML={{ __html:content?.answer }}></div>
    </div>
}

const FAQContent = props =>{
    const { data } = props;

    return <div>
        <div dangerouslySetInnerHTML={{__html: data?.main}}></div>

        {
            data?.questions?.map((content, index) => <FAQContentItem content={content} key={index} />)
        }
    </div>
}

const Faq = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state=>state.pagePolicy);
    const global = useSelector(state=>state.global);
    const { config } = global;

    const messageData = useMemo(() =>{
        if(pagePolicy?.faq){
            let headMsg = pagePolicy?.faq?.header, contentMsg = pagePolicy?.faq?.content, footerMsg = pagePolicy?.faq?.footer
            headMsg = headMsg.replace(/#siteLabel/g, config?.name);
            footerMsg = footerMsg.replace(/#siteLabel/g, config?.name);
            contentMsg?.forEach(cmg => {
                cmg.main = cmg?.main?.replace(/#siteLabel/g, config?.name);
                cmg.questions?.forEach((cmq) => {
                    cmq.title = cmq?.title?.replace(/#siteLabel/g, config?.name);
                    cmq.answer = cmq?.answer?.replace(/#siteLabel/g, config?.name);
                })
            })
            // console.log({header:headMsg,content:[...contentMsg],footerMsg:footerMsg})
            return {header:headMsg,content:[...contentMsg],footerMsg:footerMsg}; 
        } else {
            return null;
        }
    },[pagePolicy?.faq]);

    return <React.Fragment>
        {
            messageData && <React.Fragment>
                <Header centerSlot={<FormattedMessage id="faq" defaultMessage="FAQ" />} />

                <div className={classes.Container}>
                    {
                        messageData?.content?.map((item, index) =><FAQContent data={item} key={index} />)
                    }

                    <div className={classes.contentFooter} dangerouslySetInnerHTML={{ __html: messageData?.footerMsg }}></div>
                </div>
            </React.Fragment>
        }
    </React.Fragment>
}

Faq.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_global_get_init_country_message("M1733", "faq", headers))
}

export default Faq
